import { env } from './env.mjs';
import { type WebsiteRoute } from './utils/appDirTypes';

export const IN_PROD = env.NEXT_PUBLIC_NODE_ENV === 'production';
export const IN_DEV = env.NEXT_PUBLIC_NODE_ENV === 'development';

export const HOME_PAGE: WebsiteRoute = '/dashboard/dealer/profile';
export const SIGN_IN_PAGE: WebsiteRoute = '/auth/signin';
export const NO_DEALER_REDIRECT: WebsiteRoute =
  '/dashboard/noDealer/companyInfo';

export const WEBSITE_NAME = 'JCI PowerManage';
